<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：アカウント通知先選択画面(STDSDC02C17)                                                                _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isProcessShow">
    <div class="popup" style="width: 600px">
      <div class="popup-head">通知方法の選択</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p v-for="line in messageArea.split('\n')" :key="line">
          {{ line }}
        </p>
        <br />
        <div class="frm-row">
          <span class="frm-label w-150px">
            <strong>通知方法</strong>
          </span>
          <ToggleButton
            v-model="notificationMethod"
            :list="[
              { code: 0, text: 'メール通知' },
              { code: 1, text: 'Excel出力' },
            ]"
            ref="notificationMethod"
          />
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button
                tabindex="0"
                class="frm-btn strong large"
                @click="notificationSelect"
              >
                確定
              </button>
              <button
                tabindex="0"
                class="frm-btn large"
                data-role="popup-close"
                @click="cancelNotificationSelect"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import Common from "@/util/common.js";
import BaseModal from "@/components/Base/BaseModal.vue";
import ToggleButton from "@/components/ToggleButton.vue";

export default {
  name: "AccountNotifiCationSelectModal",
  components: {
    BaseModal,
    ToggleButton,
  },
  data() {
    return {
      messageArea: Common.getMessage("MTCL2120", ["事業者"]),
      notificationMethod: 0, // 通知方法(0:メール通知 1:Excel出力)
    };
  },
  props: {
    isProcessShow: {
      type: Boolean,
      required: true,
    },
  },
  computed: {},
  watch: {
    isProcessShow: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.reset();
          this.initFocus();
        });
      }
    },
  },
  methods: {
    // **********************************************
    // 確定が選択された時の処理
    // **********************************************
    notificationSelect() {
      this.$emit("notificationSelect", this.notificationMethod);
    },

    // **********************************************
    // キャンセルが選択された時の処理
    // **********************************************
    cancelNotificationSelect() {
      this.$emit("cancelNotificationSelect");
      this.reset();
    },

    // **********************************************
    // リセット
    // **********************************************
    reset() {
      this.notificationMethod = 0; // 通知方法(0:メール通知 1:Excel出力)
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.notificationMethod.focus();
    },
  },
};
</script>
		  